import React from "react"
import { TouchableOpacity } from "react-native"
import BFText from "@/components/standard/BFText"

interface EditButtonProps {
  onPress: () => void
  isLight?: boolean
  buttonText?: string
}

const EditButton: React.FC<EditButtonProps> = ({
  onPress,
  isLight = false,
  buttonText = "Edit",
}) => {
  return (
    <TouchableOpacity testID={"edit-button"} onPress={onPress} hitSlop={16}>
      <BFText
        className={`text-[12px] font-spacegrotesk underline tracking-tight pb-0 ${
          isLight ? "text-white" : "text-calm-blue"
        }`}
      >
        {buttonText}
      </BFText>
    </TouchableOpacity>
  )
}

export default EditButton
